import { Dashboard } from "../../packages/dashboard/src/Dashboard.tsx";
import type { SiteView } from "../../packages/dashboard/src/Dashboard.tsx";

function currentView(): SiteView {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/strategies") {
    window.location.replace("/performance?section=strategies&strategy=ALL");
    return "performance";
  }
  if (path === "/trades") {
    window.location.replace("/performance");
    return "performance";
  }
  const routes: Record<string, SiteView> = {
    "/": "home",
    "/performance": "performance",
    "/verification": "verification",
    "/privacy": "privacy",
    "/terms": "terms",
    "/risk-disclosure": "risk",
    "/changelog": "changelog",
    "/status": "status",
  };
  return routes[path] ?? "not-found";
}

export default function App() {
  return (
    <Dashboard
      apiBaseUrl={import.meta.env.VITE_API_BASE_URL ?? ""}
      accountId={import.meta.env.VITE_PUBLIC_ACCOUNT_ID ?? ""}
      view={currentView()}
    />
  );
}
